<!--
 * @Date: 2023-09-04 15:28:50

-->
<template>
  <bk-page class="a-map-page" pageType="navPage" :navBarInfo="navBarInfo">
    <iframe :src="iframeSrc" frameborder="0"></iframe>
  </bk-page>
</template>
  
<script>
import { navBarInfo } from './dataSource'

export default {
  name: 'AMap',
  props: {
    resShopInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    this.navBarInfo = navBarInfo
    return {}
  },

  computed: {
    iframeSrc() {
      const { lat, lng, address } = this.resShopInfo
			return `http://uri.amap.com/marker?position=${lng},${lat}&name=${address}`
    }
  }
}
</script>
  
<style lang='less' scoped>
  .a-map-page {
    position: absolute;
    z-index: 999 !important;
    width: 100vw;
    height: 100vh;
    margin-bottom: env(64px + safe-area-inset-bottom);

    iframe {
      width: 100%;
      height: 100%;
    }
  }
</style>